import Icon from '../components/Icon.vue'

Icon.register({
  'volume-down': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M215 72L126.1 161H24C10.7 161 0 171.7 0 185V329C0 342.3 10.7 353 24 353H126.1L215 441.9C230.1 457 256 446.4 256 425V89C256 67.6 230 57 215 72zM338.2 180.1C326.7 173.8 312 178 305.6 189.6 299.2 201.2 303.5 215.8 315.1 222.2 328 229.3 336 242.6 336 257 336 271.4 328 284.7 315.1 291.8 303.5 298.2 299.2 312.8 305.6 324.4 312.1 336.1 326.7 340.2 338.2 333.9 366.5 318.3 384 288.9 384 257S366.5 195.7 338.2 180.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-down.js
// module id = STt4
// module chunks = 144